import React from 'react'
import { Grid } from '../Grid'
import {
  ExpandableGridAccordionCollapse,
  ExpandableGridContainer,
} from './accordion.styles'

export type ExpandableElementGridProps = {
  gridRow?: number
  gridTemplateColumns?: string
  children: React.ReactNode | React.ReactNodeArray
  actionsRow?: JSX.Element
  noMaxHeight?: boolean
}

export function ExpandableGrid(props: ExpandableElementGridProps): JSX.Element {
  return (
    <ExpandableGridAccordionCollapse
      eventKey="0"
      $gridRow={props.gridRow}
      $noMaxHeight={props.noMaxHeight}
    >
      <ExpandableGridContainer>
        {props.actionsRow}
        <Grid gridTemplateColumns={props.gridTemplateColumns || ''}>
          {props.children}
        </Grid>
      </ExpandableGridContainer>
    </ExpandableGridAccordionCollapse>
  )
}
